import { render } from "./Drafts.vue?vue&type=template&id=333da4da"
import script from "./Drafts.vue?vue&type=script&lang=js"
export * from "./Drafts.vue?vue&type=script&lang=js"
script.render = render

export default script